const v = 'v1';
export const environment = {
  production: false,
  baseUrl: `https://xolvep2stg.fmx.asia/api/${v}`,
  rootUrl: 'https://xolvep2stg.fmx.asia',
  emsRoot: './#',
  citRoot: 'http://cittest.fmx.asia/#',
  mapApiKey: 'AIzaSyBlWTfnXcmqLj8gNJzVbxFeUP82FJDxdpE'
};
